import script from "./incomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./incomePage.vue?vue&type=script&setup=true&lang=js"

import "./incomePage.vue?vue&type=style&index=0&id=585c2d38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585c2d38"]])

export default __exports__